import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	none: {
		id: 'issue-history.common.change.none',
		defaultMessage: 'None',
		description: '(noun) Text to indicate empty value',
	},
});
